export const APP_CUSTOM_API = {
  //deploy DEV
  // DISPLAY_SERVICE: "http://103.30.126.105:9094/nmu-display-service",
  // ADMIN_SERVICE: "http://103.30.126.105:9095/nmu-admin-service",
  // ADMIN_WSK: "ws://103.30.126.105:9095/nmu-admin-service/wsk",

  //deploy PROD
  DISPLAY_SERVICE: "/nmu-display-service",
  ADMIN_SERVICE: "/nmu-management-service",
  ADMIN_WSK: "wss://www.nmu.ac.th/nmu-management-service/wsk",
};
